import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import OptionsLandschaftViewModel from '@/ViewModels/Controls/OptionsLandschaftViewModel';

export default class OptionsLandschaft extends Control {

    private control: JQuery;
    public context: OptionsLandschaftViewModel;

    public constructor(private viewModel: OptionsLandschaftViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated((widget) => {
            this.applyBindings(this.control, {
                controlName: 'optionslandschaft',
                locator: 'settings.optionslandschaft',
               
                loader: this.context.isBusy,

                controlIdent: this.identifier,

                tooltip: this.context.tooltip,

                invalid: this.context.invalidationText,

                optionsLandschaftGroups: {
                    parent: this,

                    groups: this.context.groups
                },

                visible: this.context.isVisible
            });
        });
    }

    public getControl(): JQuery {
        if (this.control != null) {
            return this.control;
        }

        this.control = this.element || $('<div>');
        this.widget(null);

        return this.control;
    }
}

ComponentManager.setControl('OptionsLandschaft', OptionsLandschaft, 'RADPresentation.HTMLClient.DefaultViewExtensions');